import { FC, lazy, Suspense } from 'react'
import { useGetMaintenancesByCage, useGetMaintenancesByEquipmentType } from 'src/api/maintenance'
import { CenteredSpinner, FlexSpinner } from 'src/components/Spinner'
import { MaintenanceViewMode } from 'src/enums'
import { ScheduledMaintenanceFilterParams } from 'src/generated-types/scheduled-maintenance-filter'
const MaintenanceTable = lazy(async () => await import('./MaintenanceTable'))

interface ScheduledMaintenanceTableRenderProps {
  customerId: EntityId
  localityId: EntityId
  category: MaintenanceViewMode
  selectedItemId: EntityId
  onlyDaily: boolean
  filterIds?: ScheduledMaintenanceFilterParams
}

const ScheduledMaintenanceTableRenderComponent: FC<ScheduledMaintenanceTableRenderProps> = ({
  customerId,
  localityId,
  category,
  selectedItemId,
  onlyDaily,
  filterIds,
}) => {
  const cageMaintenances = useGetMaintenancesByCage(customerId, localityId, selectedItemId, onlyDaily, filterIds, {
    enabled: category === MaintenanceViewMode.GroupByCage,
  })
  const equipmentMaintenances = useGetMaintenancesByEquipmentType(
    customerId,
    localityId,
    selectedItemId,
    onlyDaily,
    filterIds,
    { enabled: category === MaintenanceViewMode.GroupByEquipment },
  )

  const maintenanceData =
    category === MaintenanceViewMode.GroupByCage ? cageMaintenances?.data : equipmentMaintenances?.data

  return (
    <Suspense fallback={<CenteredSpinner containerProps={{ minHeight: 'calc(100vh * 0.3)' }} />}>
      {(cageMaintenances.isLoading || equipmentMaintenances.isLoading) && <FlexSpinner />}
      <MaintenanceTable
        maintenances={maintenanceData}
        selectedItemId={selectedItemId}
        category={category}
        onlyDaily={onlyDaily}
        filterIds={filterIds}
      />
    </Suspense>
  )
}

export default ScheduledMaintenanceTableRenderComponent
